export const loadShoppingBagDrawer = () =>
  import('@/components/ShoppingBagDrawer/ShoppingBagDrawer');

export const loadSearchOverlay = () =>
  import('@/components/SearchOverlay/SearchOverlay');

// Preloads only warm the chunk cache: a failed fetch is retried when next/dynamic mounts the overlay.
export const preloadShoppingBagDrawer = () => {
  loadShoppingBagDrawer().catch(() => undefined);
};

export const preloadSearchOverlay = () => {
  loadSearchOverlay().catch(() => undefined);
};
